/* src/app/shared/components/flow-badge-v2/flow-badge-v2.component.scss */
.flow-badge {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: fit-content;
}
.flow-badge .icon {
  height: 12px;
  width: 12px;
  flex-shrink: 0;
}
.flow-badge .divider {
  width: 1px;
  height: 40px;
}
.flow-badge.size-small {
  height: 24px;
  gap: 4px;
  border-radius: 8px;
  padding: 2px 8px;
}
.flow-badge.size-small.has-left-icon {
  padding-left: 4px;
}
.flow-badge.size-small .icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 16px;
  width: 16px;
}
.flow-badge.size-small .icon {
  height: 16px;
  width: 16px;
}
.flow-badge.size-large {
  height: 32px;
  gap: 4px;
  border-radius: 8px;
  padding: 4px 8px;
}
.flow-badge.size-large.has-left-icon {
  padding-right: 12px;
}
.flow-badge.size-large .icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 20px;
  width: 20px;
}
.flow-badge.color-neutral.type-solid {
  background-color: #e4e4e7;
}
.flow-badge.color-neutral.type-solid .body-3-medium {
  color: #18181b;
}
.flow-badge.color-neutral.type-solid .icon {
  filter: brightness(0) saturate(100%) invert(13%);
}
.flow-badge.color-neutral.type-subtle {
  background-color: #f4f4f5;
}
.flow-badge.color-neutral.type-subtle .body-3-medium {
  color: #18181b;
}
.flow-badge.color-neutral.type-subtle .icon {
  filter: brightness(0) saturate(100%) invert(36%);
}
.flow-badge.color-neutral .divider {
  background-color: #f4f4f5;
}
.flow-badge.color-info1.type-solid {
  background-color: #4568d0;
}
.flow-badge.color-info1.type-solid .body-3-medium {
  color: #ffffff;
}
.flow-badge.color-info1.type-solid .icon {
  filter: brightness(0) invert(1);
}
.flow-badge.color-info1.type-subtle {
  background-color: #e0e9f9;
}
.flow-badge.color-info1.type-subtle .body-3-medium {
  color: #3753be;
}
.flow-badge.color-info1.type-subtle .icon {
  filter: brightness(0) saturate(100%) invert(17%) sepia(81%) saturate(2106%) hue-rotate(218deg) brightness(106%) contrast(101%);
}
.flow-badge.color-info1 .divider {
  background-color: #e0e9f9;
}
.flow-badge.color-info2.type-solid {
  background-color: #9333ea;
}
.flow-badge.color-info2.type-solid .body-3-medium {
  color: #ffffff;
}
.flow-badge.color-info2.type-solid .icon {
  filter: brightness(0) invert(1);
}
.flow-badge.color-info2.type-subtle {
  background-color: #f3e8ff;
}
.flow-badge.color-info2.type-subtle .body-3-medium {
  color: #6b21a8;
}
.flow-badge.color-info2.type-subtle .icon {
  filter: brightness(0) saturate(100%) invert(14%) sepia(64%) saturate(4151%) hue-rotate(267deg) brightness(100%) contrast(96%);
}
.flow-badge.color-info2 .divider {
  background-color: #f3e8ff;
}
.flow-badge.color-success.type-solid {
  background-color: #15803d;
}
.flow-badge.color-success.type-solid .body-3-medium {
  color: #ffffff;
}
.flow-badge.color-success.type-solid .icon {
  filter: brightness(0) invert(1);
}
.flow-badge.color-success.type-subtle {
  background-color: #dcfce7;
}
.flow-badge.color-success.type-subtle .body-3-medium {
  color: #166534;
}
.flow-badge.color-success.type-subtle .icon {
  filter: brightness(0) saturate(100%) invert(27%) sepia(47%) saturate(719%) hue-rotate(90deg) brightness(100%) contrast(91%);
}
.flow-badge.color-success .divider {
  background-color: #dcfce7;
}
.flow-badge.color-warning1.type-solid {
  background-color: #facc15;
}
.flow-badge.color-warning1.type-solid .body-3-medium {
  color: #18181b;
}
.flow-badge.color-warning1.type-solid .icon {
  filter: brightness(0) saturate(100%) invert(13%);
}
.flow-badge.color-warning1.type-subtle {
  background-color: #fef08a;
}
.flow-badge.color-warning1.type-subtle .body-3-medium {
  color: #854d0e;
}
.flow-badge.color-warning1.type-subtle .icon {
  filter: brightness(0) saturate(100%) invert(29%) sepia(88%) saturate(453%) hue-rotate(351deg) brightness(94%) contrast(99%);
}
.flow-badge.color-warning1 .divider {
  background-color: #fef08a;
}
.flow-badge.color-warning2.type-solid {
  background-color: #fb923c;
}
.flow-badge.color-warning2.type-solid .body-3-medium {
  color: #18181b;
}
.flow-badge.color-warning2.type-solid .icon {
  filter: brightness(0) saturate(100%) invert(13%);
}
.flow-badge.color-warning2.type-subtle {
  background-color: #ffedd5;
}
.flow-badge.color-warning2.type-subtle .body-3-medium {
  color: #9a3412;
}
.flow-badge.color-warning2.type-subtle .icon {
  filter: brightness(0) saturate(100%) invert(27%) sepia(42%) saturate(2304%) hue-rotate(348deg) brightness(86%) contrast(99%);
}
.flow-badge.color-warning2 .divider {
  background-color: #ffedd5;
}
.flow-badge.color-destructive.type-solid {
  background-color: #dc2626;
}
.flow-badge.color-destructive.type-solid .body-3-medium {
  color: #ffffff;
}
.flow-badge.color-destructive.type-solid .icon {
  filter: brightness(0) invert(1);
}
.flow-badge.color-destructive.type-subtle {
  background-color: #fee2e2;
}
.flow-badge.color-destructive.type-subtle .body-3-medium {
  color: #b91c1c;
}
.flow-badge.color-destructive.type-subtle .icon {
  filter: brightness(0) saturate(100%) invert(17%) sepia(31%) saturate(6219%) hue-rotate(345deg) brightness(89%) contrast(99%);
}
.flow-badge.color-destructive .divider {
  background-color: #fee2e2;
}
/*# sourceMappingURL=flow-badge-v2.component.css.map */
